const setHeightForWidget = (event, document) => {
    const fdpqIframeElement = document.getElementById('fdpq-iframe');

    if (fdpqIframeElement !== null
    && event.data
    && event.data.type === 'onFdpqWidgetHeightChanged'
    && event.data.height != null) {
        const height = Number(event.data.height);
        // Only update if height actually changed to prevent unnecessary reflows
        if (fdpqIframeElement.height !== `${height}px`) {
            fdpqIframeElement.height = height + 'px';
            fdpqIframeElement.style.marginBottom = height > 0 ? '20px' : '0';
        }
        return height;
    }
    return null;
};

export default setHeightForWidget;
